"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsCrimeLocalAuthorityAttribute$ = exports.StatsCrimeLocalAuthorityAttribute$outboundSchema = exports.StatsCrimeLocalAuthorityAttribute$inboundSchema = void 0;
exports.statsCrimeLocalAuthorityAttributeToJSON = statsCrimeLocalAuthorityAttributeToJSON;
exports.statsCrimeLocalAuthorityAttributeFromJSON = statsCrimeLocalAuthorityAttributeFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const statscrimelocalauthority_js_1 = require("./statscrimelocalauthority.js");
/** @internal */
exports.StatsCrimeLocalAuthorityAttribute$inboundSchema = z.object({
    local_authority: statscrimelocalauthority_js_1.StatsCrimeLocalAuthority$inboundSchema,
    neighbouring_local_authorities: z.array(statscrimelocalauthority_js_1.StatsCrimeLocalAuthority$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "local_authority": "localAuthority",
        "neighbouring_local_authorities": "neighbouringLocalAuthorities",
    });
});
/** @internal */
exports.StatsCrimeLocalAuthorityAttribute$outboundSchema = z.object({
    localAuthority: statscrimelocalauthority_js_1.StatsCrimeLocalAuthority$outboundSchema,
    neighbouringLocalAuthorities: z.array(statscrimelocalauthority_js_1.StatsCrimeLocalAuthority$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        localAuthority: "local_authority",
        neighbouringLocalAuthorities: "neighbouring_local_authorities",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var StatsCrimeLocalAuthorityAttribute$;
(function (StatsCrimeLocalAuthorityAttribute$) {
    /** @deprecated use `StatsCrimeLocalAuthorityAttribute$inboundSchema` instead. */
    StatsCrimeLocalAuthorityAttribute$.inboundSchema = exports.StatsCrimeLocalAuthorityAttribute$inboundSchema;
    /** @deprecated use `StatsCrimeLocalAuthorityAttribute$outboundSchema` instead. */
    StatsCrimeLocalAuthorityAttribute$.outboundSchema = exports.StatsCrimeLocalAuthorityAttribute$outboundSchema;
})(StatsCrimeLocalAuthorityAttribute$ || (exports.StatsCrimeLocalAuthorityAttribute$ = StatsCrimeLocalAuthorityAttribute$ = {}));
function statsCrimeLocalAuthorityAttributeToJSON(statsCrimeLocalAuthorityAttribute) {
    return JSON.stringify(exports.StatsCrimeLocalAuthorityAttribute$outboundSchema.parse(statsCrimeLocalAuthorityAttribute));
}
function statsCrimeLocalAuthorityAttributeFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.StatsCrimeLocalAuthorityAttribute$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'StatsCrimeLocalAuthorityAttribute' from JSON`);
}
//# sourceMappingURL=statscrimelocalauthorityattribute.js.map